import { render } from "./AppSplash.vue?vue&type=template&id=6e871f9f&scoped=true"
import script from "./AppSplash.vue?vue&type=script&lang=js"
export * from "./AppSplash.vue?vue&type=script&lang=js"

import "./AppSplash.vue?vue&type=style&index=0&id=6e871f9f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e871f9f"]])

export default __exports__